import { render } from "./BillingHistory.vue?vue&type=template&id=31264d4f&scoped=true"
import script from "./BillingHistory.vue?vue&type=script&lang=js"
export * from "./BillingHistory.vue?vue&type=script&lang=js"

import "./BillingHistory.vue?vue&type=style&index=0&id=31264d4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31264d4f"]])

export default __exports__